import { render } from "./Contact.vue?vue&type=template&id=561b4aa6&scoped=true&ts=true"
import script from "./Contact.vue?vue&type=script&lang=ts"
export * from "./Contact.vue?vue&type=script&lang=ts"

import "./Contact.vue?vue&type=style&index=0&id=561b4aa6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-561b4aa6"]])

export default __exports__